import React from "react";

export default function Differentiator() {
    const data = [
        {
            dimension: "Total Cost (per year)",
            incorp: "<p class='m-0 p-0'>$100K  -  $250K</p><small>(low and predictable)</small>",
            tech: "$25 - $100 million",
            consult: "$5 - $25 million",
            inhouse: "$1 - $2 million",
            tools: "$2 - $5 million",
        },
        {
            dimension: "Time to Value",
            incorp: "<p class='m-0 p-0'>2 - 4 Weeks</p> <small>(fast with pre-built modules & no-code application)</small>",
            tech: "6 - 12 months",
            consult: "6 - 12 months",
            inhouse: "12 months",
            tools: "3 - 9 months",
        },
        {
            dimension: "Integrated Product and Applications",
            incorp: "✅ <br/>No Code AI & IOT Platform, 360Business.AI",
            tech: "❌",
            consult: "❌",
            inhouse: "❌",
            tools: "❌",
        },
        {
            dimension: "Services",
            incorp: "✅ <br />Strategy, Training, Transformation",
            tech: "❌",
            consult: "✅",
            inhouse: "❌",
            tools: "❌",
        },
        {
            dimension: "Custom AI",
            incorp: "✅",
            tech: "❌",
            consult: "✅",
            inhouse: "✅",
            tools: "❌",
        },
        {
            dimension: "Vendor Lock-In",
            incorp: "✅",
            tech: "❌",
            consult: "✅",
            inhouse: "✅",
            tools: "❌",
        },
        {
            dimension: "ERP/ Zoho Integration",
            incorp: "✅",
            tech: "❌",
            consult: "❌",
            inhouse: "✅",
            tools: "❌",
        },
        {
            dimension: "Grants & Incentives",
            incorp: "✅",
            tech: "❌",
            consult: "❌",
            inhouse: "✅",
            tools: "❌",
        },
        {
            dimension: "Proximity for Ongoing Support",
            incorp: "✅",
            tech: "❌",
            consult: "❌",
            inhouse: "✅",
            tools: "❌",
        },
        {
            dimension: "Best For",
            incorp: "Mid Market and SMB",
            tech: "Tier 1 Large Enterprises with Dev-heavy teams needing raw AI services",
            consult: "Tier 1 Large Enterprises with complex programs & big budgets",
            inhouse: "Firms with time & talent to build",
            tools: "One‑off pilots or single features",
        },
    ];

    return (
        <div className="p-3">
            <p className="text-center text-gray-600">
                Why <span className="font-semibold">Incorp.AI</span> wins: Price +
                Breadth + Speed — one partner for strategy, no-code, custom builds, ERP
                integration, hands-on support, and funding help.
            </p>
            <div className="overflow-x-auto">
                <table className="w-full border border-gray-500 text-sm">
                    <thead style={{ backgroundColor: "#EAECEE" }}>

                        <tr style={{ textAlign: 'center' }}>
                            <th className="border px-4 py-2 font-weight-bold ">Dimension</th>
                            <th className="border px-4 py-2 w-16" >Tech Giants<br />(Google/Microsoft/AWS/<br />OpenAI)</th>
                            <th className="border px-4 py-2 w-16" >Big 4 Consulting Firms<br />(Accenture/ Bain/ Deloitte/ McKinsey)</th>
                            <th className="border px-4 py-2 w-16" >Individual AI Tools</th>
                            <th className="border px-4 py-2 w-16" >In-House Team</th>
                            <th className="border px-4 py-2 w-16" style={{ backgroundColor: 'rgba(184, 222, 139, 0.42)' }}>Incorp.AI</th>
                        </tr>
                    </thead>
                    <tbody style={{ textAlign: 'center' }}>
                        {data.map((row, idx) => (
                            <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#FFFFFF" : "#F9F9F9" }}>
                                <td className={`border px-4 py-2 ${idx < 5 ? 'font-weight-bold text-blue' : ''} `} style={{ textAlign: 'left' }}>{row.dimension}</td>
                                <td className="border px-4 py-2">{row.tech}</td>
                                <td className="border px-4 py-2">{row.consult}</td>
                                <td className="border px-4 py-2">{row.tools}</td>
                                <td className="border px-4 py-2">{row.inhouse}</td>
                                <td className="border px-4 py-2" style={{ backgroundColor: 'rgba(184, 222, 139, 0.42)' }} dangerouslySetInnerHTML={{ __html: row.incorp }}></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
